import React from 'react';
import c from 'classnames';

import { useTranslation } from '@lyearn/i18n';
import { Node, useNodeStatesContext, useReactNodeView } from '@lyearn/lygo-core';
import { BaseTab, BaseTabs, Divider, Stack, Tooltip, Typography } from '@lyearn/ui';

import { TAB_CLASSES_VIEWER, TABS_PROPS } from './consts';
import { safariDoubleTooltipFix } from './styles';

const TabsComponentReadOnly: React.FC = () => {
  const { t } = useTranslation();
  const { setNodeState, getNodeState } = useNodeStatesContext();
  const { node } = useReactNodeView();
  if (!node) {
    return null;
  }

  //@ts-ignore
  const tabPanelNodes = node.content.content;

  const nodeId = node.attrs.id;

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setNodeState?.(nodeId, { activeTabId: newValue });
  };

  const activeTabId = getNodeState?.(nodeId)?.activeTabId;

  if (!activeTabId) {
    const firstTabPanelId = tabPanelNodes[0].attrs.id;
    setNodeState?.(nodeId, { activeTabId: firstTabPanelId });
  }

  return (
    <Stack
      className="tabsContainer -mx-24 my-20 rounded-16 border border-divider xs:mx-0"
      direction="col">
      <BaseTabs
        {...TABS_PROPS}
        className="px-20 pt-8"
        value={activeTabId}
        variant="scrollable"
        onChange={handleChange}>
        {tabPanelNodes.map((tabPanelNode: Node) => {
          const { id, name } = tabPanelNode.attrs;
          return (
            <BaseTab
              key={id}
              classes={TAB_CLASSES_VIEWER}
              label={
                <Tooltip
                  disableFocusListener={!name || (name && name.length < 16)}
                  disableHoverListener={!name || (name && name.length < 16)}
                  title={name || t('Lygo:Menu.tabs.UntitledTab')}>
                  <Typography
                    className={c(
                      'w-full self-start truncate normal-case text-start',
                      safariDoubleTooltipFix,
                    )}
                    color={id === activeTabId ? 'text-text-primary' : 'text-text-secondary'}
                    variant="label-01">
                    {name || t('Lygo:Menu.tabs.UntitledTab')}
                  </Typography>
                </Tooltip>
              }
              value={id}
            />
          );
        })}
      </BaseTabs>
      <Divider />
    </Stack>
  );
};

export default TabsComponentReadOnly;
